const IS_LOCAL_DEV =
  ["localhost", "127.0.0.1"].includes(window.location.hostname) ||
  /^192\.168\.|^10\.|^172\.(1[6-9]|2\d|3[01])\./.test(
    window.location.hostname
  );

const SERVER_HOST_BASE = IS_LOCAL_DEV
  ? `${window.location.protocol}//${window.location.hostname}:3977`
  : `${window.location.protocol}//${window.location.hostname}`;

export const SUCCESSARRAY = [200, 201, 202];
export const WARNIGNARRAY = [400, 401, 402, 403, 404, 405, 408];
export const ERRORARRAY = [500, 501, 502, 504];

export const ENV = {
  SERVER_HOST: SERVER_HOST_BASE,
  API_URL: `${SERVER_HOST_BASE}/api/v1`,

  TOKEN: "token",

  ENDPOINTS: {
    AUTH: {
      REGISTER: "auth/register",
      LOGIN: "auth/login",
    },

    USER: {
      USER_ME: "user/me",
      USER: "user",
      USERS: "users",
    },

    ROLE: {
      ROLE: "role",
      ROLES: "roles",
    },

    SCHEMA: {
      SCHEMA: "schema",
      SCHEMAS: "schemas",
    },

    CLASSIFICATION: {
      CLASSIFICATION: "classification",
      CLASSIFICATIONS: "classifications",
      CLASSIFICATIONS_BY_SCHEME: "classifications/scheme",
    },

    CATEGORY: {
      CATEGORY: "category",
      CATEGORIES: "categories",
    },

    PRODUCT: {
      PRODUCT: "product",
      PRODUCTS: "products",
      NEXT_SKU: "product/next-sku",
    },

    AUDIT: {
      LOGS: "audit/logs",
    },

    INVENTORY: {
      EXISTENCES: "inventory/existences",
      SUMMARY: "inventory/summary",
      MOVEMENTS: "inventory/movements",
      ENTRIES: "inventory/entries",
      EXITS: "inventory/exits",
      ADJUSTMENTS: "inventory/adjustments",
      PROFIT_SUMMARY: "inventory/profit-summary",
      MONTHLY_SALES_DETAIL: "inventory/monthly-sales-detail",
      YEARLY_SALES_DETAIL: "inventory/yearly-sales-detail",
    },

    STORE: {
      CATEGORIES: "store/categories",
      PRODUCTS: "store/products",
      PRODUCT: "store/products",
      FILTERS: "store/filters",
      SETTINGS: "store/settings",
    },

    SETTINGS: {
      SETTINGS: "settings",
    },
  },
};

export const STORE_INFO = {
  WHATSAPP_NUMBER: "50255177725",

  // TODO: confirmar si aplica y desde qué monto.
  FREE_SHIPPING_THRESHOLD: null,

  SOCIAL: {
    instagram: "https://www.instagram.com/luxnglambagclubgt",
  },
};

// ESQUEMAS

export const SSMARCA = "SSMARCA"; // 1. BALENCIAGA, 2. CHANEL, 3. HERMES, 4. GOYARD, 5. FENDI, 6. VALENTINO, 7. SAINT LAURENT, 8. GUCCI, 9. LOUIS VUITTON, 10. DIOR, 11. BOTTEGA VENETA, 12. PRADA, 13. CELINE, 14. CHLOÉ, 15. LOEWE, 16. MIUMIU, 17. MONCLER, 18. JACQUEMUS, 19. ALAÍA

export const SSCARACTERISTICA = "SSCARACTERISTICA"; // 1. Hilo bordado, 2. Costuras a mano, 3. Herrajes en metal dorado, 4. Código interno, 5. Strap en hilo bordado incluído, 6. Calfskin, 7. Lambskin, 8. Código grabado en plaqueta Chanel dentro, 9. Piel de cordero acolchada, 10. Canvas, 11. Herrajes en metal plateado, 12. Reversible, 13. Suede, 14. Tweed, 15. Denim, 16. Monogram, 17. Natural Wicker, 18. Quikted-Leather, 19. Raffia, 20. Leather

export const SSINCLUYE = "SSINCLUYE"; // 1. Caja, 2. Dust bag, 3. Etiquetas, 4. Tarjeta, 5. Shopping bag, 6. Monedero, 7. Strap a hilo bordado, 8. Imán de seguridad, 9. Cadena para cerrar

export const SACCIONES = "SACCIONES"; // 1. VIS, 2. ADD, 3. MOD, 4. DEL, 5. APR, 6. ENTRY, 7. EXIT, 8. ADJUST, 9. ACTIVATE, 10. ASSIGN_ROLES, 11. EXPORT — acciones que se pueden asignar por menú en Roles (ver ACTIONS abajo)

// Catálogo COMPLETO de códigos de acción del esquema SACCIONES -- todas
// las acciones reales que existen hoy en el panel, identificadas acá en
// un solo lugar para no repetir el string suelto (y arriesgar un typo)
// en cada página que llama a hasAction(menu, "...."). Cada código es
// específico de una operación real: nunca se reutiliza uno genérico
// entre operaciones distintas (por eso Inventario tiene ENTRY/EXIT/
// ADJUST propios en vez de compartir un "ADD", y Usuarios tiene ACTIVATE/
// ASSIGN_ROLES propios en vez de compartir "MOD"). Estos mismos códigos
// existen como clasificaciones del esquema SACCIONES en la base de datos
// (server/scripts/install-permission-scheme.js e
// insert-specific-actions.js) y como constantes espejo en
// server/constants.js para la validación del lado del servidor -- si se
// agrega una acción nueva, se agrega en los tres lugares.
export const ACTIONS = {
  VIS: "VIS", // Visualizar -- acción base: sin ella el rol no ve ese menú.
  ADD: "ADD", // Agregar (genérico: crear un registro nuevo)
  MOD: "MOD", // Modificar (genérico: editar un registro existente)
  DEL: "DEL", // Eliminar (genérico: borrado lógico de un registro)
  APR: "APR", // Aprobar -- clasificación existente, sin ningún flujo de
  // aprobación implementado todavía en el panel (no asignada a ningún
  // menú en PERMISSION_MENU_TREE).
  ENTRY: "ENTRY", // Registrar entrada -- Inventario
  EXIT: "EXIT", // Registrar salida -- Inventario
  ADJUST: "ADJUST", // Registrar ajuste -- Inventario
  ACTIVATE: "ACTIVATE", // Activar/Desactivar una cuenta -- Usuarios
  ASSIGN_ROLES: "ASSIGN_ROLES", // Asignar roles a un usuario -- Usuarios
  EXPORT: "EXPORT", // Exportar el resumen a CSV -- Resumen (Dashboard).
  // Sin acción propia en el servidor: el botón "Exportar" arma el CSV en
  // el navegador con los mismos datos de inventory/yearly-sales-detail
  // que ya se ven en pantalla (esa lectura queda abierta a cualquiera
  // con dashboard.VIS -- ver server/routes/inventory.js), así que
  // bloquear la descarga ahí no protegería nada que "Ver" no exponga ya;
  // EXPORT solo oculta/muestra el botón en el cliente.
};
